import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Radio } from '../../../../form/radio/radio';
import { useRootStore } from '../../../../../../providers/root-store-provider';
import { TabEnumAllocations } from '../../../../../../models/enums/tab-enum-allocations';

export const AllocationsPopoverSort: React.FC = observer(() => {
    const { t } = useTranslation();
    const {
        statisticStore: { ratiosStore },
    } = useRootStore();

    const isUnrealized = ratiosStore.currentTab === TabEnumAllocations.Unrealized;

    return (
        <div className="flex flex-col">
            <div className="mb-xsmall">{t('layout.settings.allocations.sortBy')}</div>
            <Radio
                checked={
                    (isUnrealized
                        ? ratiosStore.unrealizedAllocationsProfitOrder === 'liveProfitPercentage'
                        : ratiosStore.realizedAllocationsProfitOrder === 'profitPercentage') &&
                    ratiosStore.isProfitColumnSorted
                }
                onChange={() => ratiosStore.setProfitOrder(isUnrealized ? 'liveProfitPercentage' : 'profitPercentage')}
                label={t('layout.settings.allocations.percents')}
            />
            <Radio
                checked={
                    (isUnrealized
                        ? ratiosStore.unrealizedAllocationsProfitOrder === 'liveProfitValue'
                        : ratiosStore.realizedAllocationsProfitOrder === 'profitValue') &&
                    ratiosStore.isProfitColumnSorted
                }
                onChange={() => ratiosStore.setProfitOrder(isUnrealized ? 'liveProfitValue' : 'profitValue')}
                label={t('layout.settings.allocations.value')}
            />
        </div>
    );
});
